import cn from 'classnames';

import { IConDefaultType } from '..';

export enum EmailIconVariant {
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface IEmailIconProps extends IConDefaultType {
  variant?: EmailIconVariant;
}

function EmailIcon({ color, className, size = 53, rotate, flip, variant = EmailIconVariant.SUCCESS }: IEmailIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === EmailIconVariant.SUCCESS && (
        <svg viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_5116_166888"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="1"
            y="1"
            width="50"
            height="50"
          >
            <rect x="1" y="1" width="50" height="50" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_5116_166888)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26 1C39.7851 1 51 12.2147 51 25.9996C51 39.7846 39.7849 51 26 51C22.0273 51 18.2192 50.0878 14.7038 48.2984C14.4002 48.1762 14.1275 48.1195 13.838 48.1195C13.4431 48.1195 12.993 48.2226 12.342 48.463L11.9991 48.5948L11.2294 48.9156L8.98208 49.8978C8.71143 50.0044 8.42517 50.0756 8.15537 50.0756C7.10957 50.0756 6.24421 49.2907 6.11779 48.2647L6.1019 48.0035L6.11736 47.8117L6.20215 47.3505L6.61036 45.257L6.74616 44.4983L6.84072 43.8756L6.87194 43.6129L6.89224 43.3867L6.9039 42.9744C6.89847 42.7473 6.8704 42.5561 6.81573 42.3723L6.71325 42.0986L6.56338 41.8016L6.38361 41.4887C2.86154 37.0348 1 31.6792 1 25.9996C1 12.2147 12.2149 1 26 1ZM26 4.24324C14.0061 4.24324 4.24324 14.0059 4.24324 25.9996C4.24324 30.8152 5.77224 35.3443 8.68189 39.1606L9.07626 39.665L9.41926 40.262L9.68857 40.7957L9.89241 41.3403L9.92433 41.4476C10.0413 41.8406 10.109 42.2357 10.1353 42.6476L10.1462 42.8969L10.1482 42.9815L10.1314 43.5776L10.0925 43.9959L10.0613 44.2585L10.0472 44.3625L9.93867 45.0696L9.79366 45.8777L9.76634 46.0155L9.98174 45.9219L10.7515 45.6011L11.2184 45.4206C12.197 45.0592 12.9943 44.8762 13.838 44.8762C14.467 44.8762 15.0669 44.9842 15.6608 45.1938L15.915 45.2898L16.0476 45.3432L16.1749 45.4081C19.2362 46.9662 22.5404 47.7568 26 47.7568C37.9937 47.7568 47.7568 37.9935 47.7568 25.9996C47.7568 14.0059 37.9939 4.24324 26 4.24324ZM18.398 26.0905C18.398 24.3929 17.0217 23.0166 15.324 23.0166C13.6263 23.0166 12.25 24.3929 12.25 26.0905C12.25 27.7882 13.6263 29.1644 15.324 29.1644C17.0217 29.1644 18.398 27.7882 18.398 26.0905ZM39.8004 26.0905C39.8004 24.3929 38.4241 23.0166 36.7264 23.0166C35.0288 23.0166 33.6525 24.3929 33.6525 26.0905C33.6525 27.7882 35.0288 29.1644 36.7264 29.1644C38.4241 29.1644 39.8004 27.7882 39.8004 26.0905ZM26 30.8495C28.2088 30.8495 30 29.0584 30 26.8496H22C22 29.0584 23.7912 30.8495 26 30.8495Z"
              fill="#131415"
            />
          </g>
          <path
            d="M42.5 33C47.744 33 52 37.256 52 42.5C52 47.744 47.744 52 42.5 52C37.256 52 33 47.744 33 42.5C33 37.256 37.256 33 42.5 33Z"
            fill="#00C3DD"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M47.3661 39.0969C47.7371 39.4679 47.7371 40.0694 47.3661 40.4404L41.6281 46.1784C41.4499 46.3566 41.2083 46.4567 40.9563 46.4567C40.7044 46.4567 40.4628 46.3566 40.2846 46.1784L37.9096 43.8034C37.5386 43.4324 37.5386 42.8309 37.9096 42.4599C38.2806 42.0889 38.8821 42.0889 39.2531 42.4599L40.9563 44.1632L46.0226 39.0969C46.3936 38.7259 46.9951 38.7259 47.3661 39.0969Z"
            fill="white"
          />
        </svg>
      )}
      {variant === EmailIconVariant.ERROR && (
        <svg viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask
            id="mask0_2688_47761"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="1"
            y="1"
            width="50"
            height="50"
          >
            <rect x="1" y="1" width="50" height="50" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_2688_47761)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26 1C39.7851 1 51 12.2147 51 25.9996C51 39.7846 39.7849 51 26 51C22.0273 51 18.2192 50.0878 14.7038 48.2984C14.4002 48.1762 14.1275 48.1195 13.838 48.1195C13.4431 48.1195 12.993 48.2226 12.342 48.463L11.9991 48.5948L11.2294 48.9156L8.98208 49.8978C8.71143 50.0044 8.42517 50.0756 8.15537 50.0756C7.10957 50.0756 6.24421 49.2907 6.11779 48.2647L6.1019 48.0035L6.11736 47.8117L6.20215 47.3505L6.61036 45.257L6.74616 44.4983L6.84072 43.8756L6.87194 43.6129L6.89224 43.3867L6.9039 42.9744C6.89847 42.7473 6.8704 42.5561 6.81573 42.3723L6.71325 42.0986L6.56338 41.8016L6.38361 41.4887C2.86154 37.0348 1 31.6792 1 25.9996C1 12.2147 12.2149 1 26 1ZM26 4.24324C14.0061 4.24324 4.24324 14.0059 4.24324 25.9996C4.24324 30.8152 5.77224 35.3443 8.68189 39.1606L9.07626 39.665L9.41926 40.262L9.68857 40.7957L9.89241 41.3403L9.92433 41.4476C10.0413 41.8406 10.109 42.2357 10.1353 42.6476L10.1462 42.8969L10.1482 42.9815L10.1314 43.5776L10.0925 43.9959L10.0613 44.2585L10.0472 44.3625L9.93867 45.0696L9.79366 45.8777L9.76634 46.0155L9.98174 45.9219L10.7515 45.6011L11.2184 45.4206C12.197 45.0592 12.9943 44.8762 13.838 44.8762C14.467 44.8762 15.0669 44.9842 15.6608 45.1938L15.915 45.2898L16.0476 45.3432L16.1749 45.4081C19.2362 46.9662 22.5404 47.7568 26 47.7568C37.9937 47.7568 47.7568 37.9935 47.7568 25.9996C47.7568 14.0059 37.9939 4.24324 26 4.24324ZM18.398 26.0905C18.398 24.3929 17.0217 23.0166 15.324 23.0166C13.6263 23.0166 12.25 24.3929 12.25 26.0905C12.25 27.7882 13.6263 29.1644 15.324 29.1644C17.0217 29.1644 18.398 27.7882 18.398 26.0905ZM39.8004 26.0905C39.8004 24.3929 38.4241 23.0166 36.7264 23.0166C35.0288 23.0166 33.6525 24.3929 33.6525 26.0905C33.6525 27.7882 35.0288 29.1644 36.7264 29.1644C38.4241 29.1644 39.8004 27.7882 39.8004 26.0905ZM26 30.8495C28.2088 30.8495 30 29.0584 30 26.8496H22C22 29.0584 23.7912 30.8495 26 30.8495Z"
              fill="#131415"
            />
          </g>
          <circle cx="42.5" cy="42.5" r="9.5" fill="#BCBCBC" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M42.8528 44.2382L43.9737 38.6344C44.0319 38.347 43.9397 38.05 43.6971 37.7435C43.4545 37.437 43.0566 37.2837 42.5035 37.2837C41.9212 37.2837 41.5136 37.4346 41.2807 37.7363C41.0478 38.0381 40.9653 38.3374 41.0333 38.6344L42.1396 44.2382C42.1493 44.3149 42.1929 44.3651 42.2706 44.3891C42.3482 44.413 42.4259 44.425 42.5035 44.425C42.5714 44.425 42.6466 44.4106 42.7291 44.3819C42.8116 44.3532 42.8528 44.3053 42.8528 44.2382ZM43.3404 47.3642C43.5781 47.1295 43.697 46.8541 43.697 46.538C43.697 46.2219 43.5781 45.9465 43.3404 45.7118C43.1026 45.4771 42.8236 45.3597 42.5034 45.3597C42.1637 45.3597 41.8799 45.4723 41.6518 45.6974C41.4237 45.9225 41.3097 46.2027 41.3097 46.538C41.3097 46.8541 41.4286 47.1295 41.6664 47.3642C41.9041 47.5989 42.1831 47.7162 42.5034 47.7162C42.8236 47.7162 43.1026 47.5989 43.3404 47.3642Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default EmailIcon;
